import useInput from "@/app/_components/forms/useInput";
import {useCallback} from "react";
import {ContactFormParentFields} from "./contactFormUtils";

export type ParentFieldHandlers = {
	onParentFirstNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onParentLastNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onParentEmailChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onParentPhoneNumberChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	resetParentFields: () => void;
};

export type UseParentFields = ContactFormParentFields & ParentFieldHandlers;

const useContactFormParentFields: () => UseParentFields = () => {
	// setup parent fields
	const [
		parentFirstName,
		{onInputChange: onParentFirstNameChange, setInputValue: setParentFirstName},
	] = useInput();
	const [
		parentLastName,
		{onInputChange: onParentLastNameChange, setInputValue: setParentLastName},
	] = useInput();
	const [
		parentEmail,
		{onInputChange: onParentEmailChange, setInputValue: setParentEmail},
	] = useInput();

	const [
		parentPhoneNumber,
		{
			onInputChange: onParentPhoneNumberChange,
			setInputValue: setParentPhoneNumber,
		},
	] = useInput();

	const resetParentFields = useCallback(() => {
		setParentFirstName("");
		setParentLastName("");
		setParentEmail("");
		setParentPhoneNumber("");
	}, [
		setParentEmail,
		setParentFirstName,
		setParentLastName,
		setParentPhoneNumber,
	]);

	return {
		parentFirstName,
		parentLastName,
		parentEmail,
		parentPhoneNumber,
		onParentFirstNameChange,
		onParentLastNameChange,
		onParentEmailChange,
		onParentPhoneNumberChange,
		resetParentFields,
	};
};

export default useContactFormParentFields;
